module.exports = __webpack_public_path__ + "static/media/anhngu-diem10.e9802eec.png";